import App from './main/typescript/App';
import {createRoot} from 'react-dom/client';
import FunctionHelper from "./main/typescript/shared/helper/FunctionHelper";

const container = document.getElementById('root');
if (FunctionHelper.exists(container)) {
	const root = createRoot(container!);
	root.render(<App/>);
}
